import type {
  DigestLogEntry,
  ProjectContextResponse,
  RegistryToolResponse,
  RecommendResponse,
} from '../types/api';

const BASE = import.meta.env.VITE_API_BASE_URL ?? '/api/v1';

export async function searchRegistry(
  q: string,
  stack: string[],
  limit = 50,
): Promise<RegistryToolResponse[]> {
  const params = new URLSearchParams({ q, limit: String(limit) });
  stack.forEach((s) => params.append('stack', s));
  const res = await fetch(`${BASE}/registry/search?${params}`);
  if (!res.ok) throw new Error(`Registry search failed: ${res.status}`);
  return res.json() as Promise<RegistryToolResponse[]>;
}

export async function getRecommendations(
  context: ProjectContextResponse,
  installed: string[],
  limit = 20,
): Promise<RecommendResponse> {
  const res = await fetch(`${BASE}/recommend?limit=${limit}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ context, installed }),
  });
  if (!res.ok) throw new Error(`Recommend failed: ${res.status}`);
  return res.json() as Promise<RecommendResponse>;
}

export async function getRegistryCount(): Promise<{ total: number }> {
  const res = await fetch(`${BASE}/registry/count`);
  if (!res.ok) throw new Error(`Registry count failed: ${res.status}`);
  return res.json() as Promise<{ total: number }>;
}

export interface CreateToolPayload {
  slug: string;
  name: string;
  type: 'mcp' | 'skill' | 'plugin';
  description: string;
  keywords: string[];
  install_cmd: string;
  requires_api_key: boolean;
  weekly_downloads: number;
}

export async function createTool(payload: CreateToolPayload): Promise<RegistryToolResponse> {
  const res = await fetch(`${BASE}/registry/tools`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const err = await res.text();
    throw new Error(`Create tool failed: ${res.status} — ${err}`);
  }
  return res.json() as Promise<RegistryToolResponse>;
}

export async function getDigestHistory(limit = 10): Promise<DigestLogEntry[]> {
  const res = await fetch(`${BASE}/digest/history?limit=${limit}`);
  if (!res.ok) throw new Error(`Digest history failed: ${res.status}`);
  return res.json() as Promise<DigestLogEntry[]>;
}
